/**
 * Permission Keys Constants
 * These constants represent permission keys used throughout the application
 * Permission keys are derived from permission strings and converted to uppercase with underscores
 */

// Ticket Management Permissions
export const CREATE_TICKET = 'CREATE_TICKET';
export const ALL_TICKETS = 'ALL_TICKETS';
export const MY_TICKETS = 'MY_TICKETS';
export const MY_ASSIGNED_TICKETS = 'MY_ASSIGNED_TICKETS';
export const AWAITING_CLOSURE_TICKETS = 'AWAITING_CLOSURE_TICKETS';
export const CLOSED_TICKETS = 'CLOSED_TICKETS';
export const MY_PREVIOUS_TICKETS = 'MY_PREVIOUS_TICKETS';
export const TICKET_HISTORY = 'TICKET_HISTORY';
export const PENDING_APPROVALS = 'PENDING_APPROVALS';
export const VIEW_TICKET_DETAIL = 'VIEW_TICKET_DETAIL';
export const QUEUE_MANAGER_TICKETS = 'QUEUE_MANAGER_TICKETS';
export const REJECT_TICKET = 'REJECT_TICKET';
export const APPROVE_TICKET = 'APPROVE_TICKET';
export const UPDATE_TICKET_STATUS = 'UPDATE_TICKET_STATUS';
export const ASSIGN_TO_CONSULTANT = 'ASSIGN_TO_CONSULTANT';
export const FORWARD_TO_APPROVER = 'FORWARD_TO_APPROVER';
export const TICKET_LIST_BY_SUBCOMPANY = 'TICKET_LIST_BY_SUBCOMPANY';

// User Management Permissions
export const USER_REGISTRATION = 'USER_REGISTRATION';
export const USER_LIST = 'USER_LIST';
export const USER_DELETE = 'USER_DELETE';
export const USER_EDIT = 'USER_EDIT';
export const CONSULTANT_REGISTRATION = 'CONSULTANT_REGISTRATION';
export const USER_GROUPS = 'USER_GROUPS';

// Access Control Permissions
export const VIEW_ROLES = 'VIEW_ROLES';
export const CREATE_ROLE = 'CREATE_ROLE';
export const EDIT_ROLE = 'EDIT_ROLE';
export const DELETE_ROLE = 'DELETE_ROLE';
export const VIEW_PERMISSIONS = 'VIEW_PERMISSIONS';
export const CREATE_PERMISSION = 'CREATE_PERMISSION';
export const EDIT_PERMISSION = 'EDIT_PERMISSION';
export const DELETE_PERMISSION = 'DELETE_PERMISSION';
export const VIEW_OPERATIONS = 'VIEW_OPERATIONS';
export const ACCESS_CONTROL = 'ACCESS_CONTROL';

// Company Management Permissions
export const COMPANY_LIST = 'COMPANY_LIST';
export const CUSTOMER_DETAILS = 'CUSTOMER_DETAILS';
export const VIEW_COMPANY_DETAILS = 'VIEW_COMPANY_DETAILS';
export const COMPANY_GROUPS = 'COMPANY_GROUPS';

// Change Request
export const CHANGE_REQUESTS = 'CHANGE_REQUESTS';
export const CREATE_CHANGE_REQUEST = 'CREATE_CHANGE_REQUEST';
export const CHANGE_REQUEST_PENDING_APPROVALS = 'CHANGE_REQUEST_PENDING_APPROVALS';
export const CHANGE_REQUESTS_CREATED_BY_ME = 'CHANGE_REQUESTS_CREATED_BY_ME';
export const CHANGE_REQUESTS_ASSIGNED_TO_ME = 'CHANGE_REQUESTS_ASSIGNED_TO_ME';
export const MY_PREVIOUS_CHANGE_REQUESTS = 'MY_PREVIOUS_CHANGE_REQUESTS';
export const CHANGE_REQUEST_EFFORTS_VIEW = 'CHANGE_REQUEST_EFFORTS_VIEW';
export const CHANGE_REQUEST_EFFORTS_ADD = 'CHANGE_REQUEST_EFFORTS_ADD';
export const CHANGE_REQUEST_SOLUTIONS_VIEW = 'CHANGE_REQUEST_SOLUTIONS_VIEW';
export const CHANGE_REQUEST_SOLUTIONS_ADD = 'CHANGE_REQUEST_SOLUTIONS_ADD';
export const CHANGE_REQUEST_ASSIGN_TO_CONSULTANT = 'CHANGE_REQUEST_ASSIGN_TO_CONSULTANT';
export const CHANGE_REQUEST_UPDATE_STATUS = 'CHANGE_REQUEST_UPDATE_STATUS';
export const CHANGE_REQUEST_UPDATE_PHASE = 'CHANGE_REQUEST_UPDATE_PHASE';
export const CHANGE_REQUEST_CHANGE_APPROVER = 'CHANGE_REQUEST_CHANGE_APPROVER';
export const CHANGE_REQUEST_QUEUE_MANAGER_LIST = 'CHANGE_REQUEST_QUEUE_MANAGER_LIST';

// System Configuration Permissions
export const MASTER_DATA = 'MASTER_DATA';
export const FEATURES = 'FEATURES';
export const BANNER_MANAGEMENT = 'BANNER_MANAGEMENT';
export const APPROVAL_WORKFLOW = 'APPROVAL_WORKFLOW';

// Notifications
export const NOTIFICATIONS = 'NOTIFICATIONS';

// Dashboard
export const ANALYSIS = 'ANALYSIS';
export const SUPER_ADMIN_DASHBOARD = 'SUPER_ADMIN_DASHBOARD';
export const ADMIN_DASHBOARD = 'ADMIN_DASHBOARD';
export const USER_DASHBOARD = 'USER_DASHBOARD';
export const QUEUE_MANAGER_DASHBOARD = 'QUEUE_MANAGER_DASHBOARD';
export const APPROVER_DASHBOARD = 'APPROVER_DASHBOARD';
export const CONSULTANT_DASHBOARD = 'CONSULTANT_DASHBOARD';

// Approver Management
export const APPROVER = 'APPROVER';

// User Profile
export const USER_PROFILE = 'USER_PROFILE';

export const ALL_PERMISSION_KEYS = [
  CREATE_TICKET,
  ALL_TICKETS,
  MY_TICKETS,
  MY_ASSIGNED_TICKETS,
  AWAITING_CLOSURE_TICKETS,
  CLOSED_TICKETS,
  MY_PREVIOUS_TICKETS,
  TICKET_HISTORY,
  PENDING_APPROVALS,
  VIEW_TICKET_DETAIL,
  QUEUE_MANAGER_TICKETS,
  REJECT_TICKET,
  APPROVE_TICKET,
  UPDATE_TICKET_STATUS,
  ASSIGN_TO_CONSULTANT,
  FORWARD_TO_APPROVER,
  TICKET_LIST_BY_SUBCOMPANY,
  USER_REGISTRATION,
  USER_LIST,
  USER_DELETE,
  USER_EDIT,
  CONSULTANT_REGISTRATION,
  USER_GROUPS,
  VIEW_ROLES,
  CREATE_ROLE,
  EDIT_ROLE,
  DELETE_ROLE,
  VIEW_PERMISSIONS,
  CREATE_PERMISSION,
  EDIT_PERMISSION,
  DELETE_PERMISSION,
  VIEW_OPERATIONS,
  ACCESS_CONTROL,
  COMPANY_LIST,
  CUSTOMER_DETAILS,
  VIEW_COMPANY_DETAILS,
  COMPANY_GROUPS,
  CHANGE_REQUESTS,
  CREATE_CHANGE_REQUEST,
  CHANGE_REQUEST_PENDING_APPROVALS,
  CHANGE_REQUESTS_CREATED_BY_ME,
  CHANGE_REQUESTS_ASSIGNED_TO_ME,
  MY_PREVIOUS_CHANGE_REQUESTS,
  CHANGE_REQUEST_EFFORTS_VIEW,
  CHANGE_REQUEST_EFFORTS_ADD,
  CHANGE_REQUEST_SOLUTIONS_VIEW,
  CHANGE_REQUEST_SOLUTIONS_ADD,
  CHANGE_REQUEST_ASSIGN_TO_CONSULTANT,
  CHANGE_REQUEST_UPDATE_STATUS,
  CHANGE_REQUEST_UPDATE_PHASE,
  CHANGE_REQUEST_CHANGE_APPROVER,
  CHANGE_REQUEST_QUEUE_MANAGER_LIST,
  MASTER_DATA,
  FEATURES,
  BANNER_MANAGEMENT,
  APPROVAL_WORKFLOW,
  NOTIFICATIONS,
  ANALYSIS,
  SUPER_ADMIN_DASHBOARD,
  ADMIN_DASHBOARD,
  USER_DASHBOARD,
  QUEUE_MANAGER_DASHBOARD,
  APPROVER_DASHBOARD,
  CONSULTANT_DASHBOARD,
  APPROVER,
  USER_PROFILE,
];

/**
 * Maps permission string from API response to permission key constant
 * @param {string} permissionString - Permission string from API (e.g., "Create Ticket", "All Tickets")
 * @returns {string|null} Permission key constant or null if not found
 */
export const permissionStringToKey = (permissionString) => {
  if (!permissionString) return null;

  // Normalize: uppercase, replace non-alphanumerics with underscores
  const normalized = permissionString
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  // Direct mapping of permission strings to keys (explicit only)
  const permissionMap = {
    'CREATE_TICKET': CREATE_TICKET,
    'ALL_TICKETS': ALL_TICKETS,
    'MY_TICKETS': MY_TICKETS,
    'MY_ASSIGNED_TICKETS': MY_ASSIGNED_TICKETS,
    'AWAITING_CLOSURE_TICKETS': AWAITING_CLOSURE_TICKETS,
    'AWAITING_CLOSURE': AWAITING_CLOSURE_TICKETS,
    'AWAITING_CLOSURE_TICKET': AWAITING_CLOSURE_TICKETS,
    'TICKETS_AWAITING_CLOSURE': AWAITING_CLOSURE_TICKETS,
    'CLOSED_TICKETS': CLOSED_TICKETS,
    'MY_CLOSED_TICKETS': CLOSED_TICKETS,
    'CLOSED_TICKET': CLOSED_TICKETS,
    'MY_CLOSED_TICKET': CLOSED_TICKETS,
    'MY_PREVIOUS_TICKETS': MY_PREVIOUS_TICKETS,
    'PREVIOUS_TICKETS': MY_PREVIOUS_TICKETS,
    'MY_PREVIOUS_TICKET': MY_PREVIOUS_TICKETS,
    'TICKET_HISTORY': TICKET_HISTORY,
    'PENDING_APPROVALS': PENDING_APPROVALS,
    'VIEW_TICKET_DETAIL': VIEW_TICKET_DETAIL,
    'QUEUE_MANAGER_TICKETS': QUEUE_MANAGER_TICKETS,
    'REJECT_TICKET': REJECT_TICKET,
    'APPROVE_TICKET': APPROVE_TICKET,
    'UPDATE_TICKET_STATUS': UPDATE_TICKET_STATUS,
    'ASSIGN_TO_CONSULTANT': ASSIGN_TO_CONSULTANT,
    'FORWARD_TO_APPROVER': FORWARD_TO_APPROVER,
    'TICKET_LIST_BY_SUBCOMPANY': TICKET_LIST_BY_SUBCOMPANY,
    'TICKET_LIST_BY_SUBCOMPANIES': TICKET_LIST_BY_SUBCOMPANY,
    'SUBCOMPANY_TICKET_LIST': TICKET_LIST_BY_SUBCOMPANY,
    'SUB_COMPANY_TICKET_LIST': TICKET_LIST_BY_SUBCOMPANY,
    'SUBCOMPANY_TICKETS': TICKET_LIST_BY_SUBCOMPANY,
    'TICKETS_BY_SUBCOMPANY': TICKET_LIST_BY_SUBCOMPANY,
    'USER_REGISTRATION': USER_REGISTRATION,
    'USER_LIST': USER_LIST,
    'USER_DELETE': USER_DELETE,
    'USER_EDIT': USER_EDIT,
    'CONSULTANT_REGISTRATION': CONSULTANT_REGISTRATION,
    'USER_GROUPS': USER_GROUPS,
    'VIEW_ROLES': VIEW_ROLES,
    'CREATE_ROLE': CREATE_ROLE,
    'EDIT_ROLE': EDIT_ROLE,
    'DELETE_ROLE': DELETE_ROLE,
    'VIEW_PERMISSIONS': VIEW_PERMISSIONS,
    'CREATE_PERMISSION': CREATE_PERMISSION,
    'EDIT_PERMISSION': EDIT_PERMISSION,
    'DELETE_PERMISSION': DELETE_PERMISSION,
    'VIEW_OPERATIONS': VIEW_OPERATIONS,
    'ACCESS_CONTROL': ACCESS_CONTROL,
    'COMPANY_LIST': COMPANY_LIST,
    'CUSTOMER_DETAILS': CUSTOMER_DETAILS,
    'VIEW_COMPANY_DETAILS': VIEW_COMPANY_DETAILS,
    'CHANGE_REQUESTS': CHANGE_REQUESTS,
    'CHANGE_REQUEST': CHANGE_REQUESTS,
    'CREATE_CHANGE_REQUEST': CREATE_CHANGE_REQUEST,
    'CHANGE_REQUEST_PENDING_APPROVALS': CHANGE_REQUEST_PENDING_APPROVALS,
    'PENDING_CHANGE_REQUEST_APPROVALS': CHANGE_REQUEST_PENDING_APPROVALS,
    'CHANGE_REQUESTS_PENDING_APPROVALS': CHANGE_REQUEST_PENDING_APPROVALS,
    'CHANGE_REQUESTS_CREATED_BY_ME': CHANGE_REQUESTS_CREATED_BY_ME,
    'CHANGE_REQUEST_CREATED_BY_ME': CHANGE_REQUESTS_CREATED_BY_ME,
    'CREATED_BY_ME_CHANGE_REQUESTS': CHANGE_REQUESTS_CREATED_BY_ME,
    'CHANGE_REQUESTS_ASSIGNED_TO_ME': CHANGE_REQUESTS_ASSIGNED_TO_ME,
    'CHANGE_REQUEST_ASSIGNED_TO_ME': CHANGE_REQUESTS_ASSIGNED_TO_ME,
    'ASSIGNED_TO_ME_CHANGE_REQUESTS': CHANGE_REQUESTS_ASSIGNED_TO_ME,
    'MY_PREVIOUS_CHANGE_REQUESTS': MY_PREVIOUS_CHANGE_REQUESTS,
    'MY_PREVIOUS_CHANGE_REQUEST': MY_PREVIOUS_CHANGE_REQUESTS,
    'PREVIOUS_CHANGE_REQUESTS': MY_PREVIOUS_CHANGE_REQUESTS,
    'CHANGE_REQUESTS_CC': MY_PREVIOUS_CHANGE_REQUESTS,
    'CHANGE_REQUEST_CC': MY_PREVIOUS_CHANGE_REQUESTS,
    'CC_CHANGE_REQUESTS': MY_PREVIOUS_CHANGE_REQUESTS,
    'CHANGE_REQUEST_EFFORTS_VIEW': CHANGE_REQUEST_EFFORTS_VIEW,
    'VIEW_CHANGE_REQUEST_EFFORTS': CHANGE_REQUEST_EFFORTS_VIEW,
    'CHANGE_REQUEST_EFFORT_VIEW': CHANGE_REQUEST_EFFORTS_VIEW,
    'CHANGE_REQUEST_EFFORTS_ADD': CHANGE_REQUEST_EFFORTS_ADD,
    'ADD_CHANGE_REQUEST_EFFORTS': CHANGE_REQUEST_EFFORTS_ADD,
    'CREATE_CHANGE_REQUEST_EFFORT': CHANGE_REQUEST_EFFORTS_ADD,
    'CHANGE_REQUEST_EFFORT_ADD': CHANGE_REQUEST_EFFORTS_ADD,
    'CHANGE_REQUEST_SOLUTIONS_VIEW': CHANGE_REQUEST_SOLUTIONS_VIEW,
    'VIEW_CHANGE_REQUEST_SOLUTIONS': CHANGE_REQUEST_SOLUTIONS_VIEW,
    'CHANGE_REQUEST_SOLUTION_VIEW': CHANGE_REQUEST_SOLUTIONS_VIEW,
    'CHANGE_REQUEST_SOLUTIONS_ADD': CHANGE_REQUEST_SOLUTIONS_ADD,
    'ADD_CHANGE_REQUEST_SOLUTIONS': CHANGE_REQUEST_SOLUTIONS_ADD,
    'CREATE_CHANGE_REQUEST_SOLUTION': CHANGE_REQUEST_SOLUTIONS_ADD,
    'CHANGE_REQUEST_SOLUTION_ADD': CHANGE_REQUEST_SOLUTIONS_ADD,
    'CHANGE_REQUEST_ASSIGN_TO_CONSULTANT': CHANGE_REQUEST_ASSIGN_TO_CONSULTANT,
    'ASSIGN_CHANGE_REQUEST': CHANGE_REQUEST_ASSIGN_TO_CONSULTANT,
    'CHANGE_REQUEST_ASSIGN_TO': CHANGE_REQUEST_ASSIGN_TO_CONSULTANT,
    'ASSIGN_TO_CONSULTANT_CHANGE_REQUEST': CHANGE_REQUEST_ASSIGN_TO_CONSULTANT,
    'CHANGE_REQUEST_UPDATE_STATUS': CHANGE_REQUEST_UPDATE_STATUS,
    'UPDATE_CHANGE_REQUEST_STATUS': CHANGE_REQUEST_UPDATE_STATUS,
    'CHANGE_REQUEST_STATUS_UPDATE': CHANGE_REQUEST_UPDATE_STATUS,
    'UPDATE_CR_STATUS': CHANGE_REQUEST_UPDATE_STATUS,
    'CHANGE_REQUEST_UPDATE_PHASE': CHANGE_REQUEST_UPDATE_PHASE,
    'UPDATE_CHANGE_REQUEST_PHASE': CHANGE_REQUEST_UPDATE_PHASE,
    'CHANGE_REQUEST_PHASE_UPDATE': CHANGE_REQUEST_UPDATE_PHASE,
    'UPDATE_CR_PHASE': CHANGE_REQUEST_UPDATE_PHASE,
    'CHANGE_REQUEST_CHANGE_APPROVER': CHANGE_REQUEST_CHANGE_APPROVER,
    'CHANGE_CR_APPROVER': CHANGE_REQUEST_CHANGE_APPROVER,
    'CHANGE_REQUEST_FORWARD_TO_APPROVER': CHANGE_REQUEST_CHANGE_APPROVER,
    'FORWARD_CHANGE_REQUEST_APPROVER': CHANGE_REQUEST_CHANGE_APPROVER,
    'CHANGE_REQUEST_QUEUE_MANAGER_LIST': CHANGE_REQUEST_QUEUE_MANAGER_LIST,
    'CHANGE_REQUEST_QM_LIST': CHANGE_REQUEST_QUEUE_MANAGER_LIST,
    'CHANGE_REQUESTS_QM_READY': CHANGE_REQUEST_QUEUE_MANAGER_LIST,
    'QUEUE_MANAGER_CHANGE_REQUEST_LIST': CHANGE_REQUEST_QUEUE_MANAGER_LIST,
    'CHANGE_REQUEST_QUEUE_MANAGER': CHANGE_REQUEST_QUEUE_MANAGER_LIST,
    // API/string aliases
    'CREATE_CHANGE_REQUESTS': CREATE_CHANGE_REQUEST,
    'MASTER_DATA': MASTER_DATA,
    'FEATURES': FEATURES,
    'BANNER_MANAGEMENT': BANNER_MANAGEMENT,
    'APPROVAL_WORKFLOW': APPROVAL_WORKFLOW,
    'APPROVAL_WORKFLOW_CONFIGURATION': APPROVAL_WORKFLOW,
    'NOTIFICATIONS': NOTIFICATIONS,
    'ANALYSIS': ANALYSIS,
    'SUPER_ADMIN_DASHBOARD': SUPER_ADMIN_DASHBOARD,
    'ADMIN_DASHBOARD': ADMIN_DASHBOARD,
    'USER_DASHBOARD': USER_DASHBOARD,
    'QUEUE_MANAGER_DASHBOARD': QUEUE_MANAGER_DASHBOARD,
    'APPROVER_DASHBOARD': APPROVER_DASHBOARD,
    'CONSULTANT_DASHBOARD': CONSULTANT_DASHBOARD,
    'APPROVER': APPROVER,
    'USER_PROFILE': USER_PROFILE,
    // Known aliases from API
    'CREATE_TICKET_PERMISSION': CREATE_TICKET,
    'ALL_TICKETS_PERMISSION': ALL_TICKETS,
  };

  // Try exact match first
  if (permissionMap[normalized]) {
    return permissionMap[normalized];
  }

  return null;
};

/**
 * Gets all unique permissions from entitlement response
 * @param {Object} entitlement - User entitlement from API
 * @returns {Array<string>} Array of permission keys
 */
export const getPermissionsFromEntitlement = (entitlement) => {
  if (!entitlement?.role) {
    return [];
  }

  const roleName = entitlement.role?.name?.replace(/^ROLE_/, '');
  if (roleName === 'SUPER_ADMIN') {
    return [...ALL_PERMISSION_KEYS];
  }

  const permissions = new Set();

  if (Array.isArray(entitlement.role.permissions)) {
    entitlement.role.permissions.forEach((permission) => {
      if (permission?.permission) {
        const permissionKey = permissionStringToKey(permission.permission);
        if (permissionKey) {
          permissions.add(permissionKey);
        }
      }
    });
  }

  return Array.from(permissions);
};
